<template>
  <div class="bottom-map">
    <div class="bottom-item" @click="handleSearch">
      <a-tooltip title="查询">
        <div class="icon-wrapper">
          <img src="@/assets/myImg/1/icon-ss.png" alt="查询" />
        </div>
      </a-tooltip>
    </div>
    <div class="bottom-item" @click="handlePositioning">
      <a-tooltip title="定位">
        <div class="icon-wrapper">
          <img src="@/assets/myImg/1/定位.png" alt="定位" />
        </div>
      </a-tooltip>
    </div>
    <div class="bottom-item" @click="handleMeasureTool">
      <a-tooltip title="测量">
        <div class="icon-wrapper">
          <img src="@/assets/myImg/1/测量.png" alt="测量" />
        </div>
      </a-tooltip>
    </div>
    <div class="bottom-item" @click="handleExportTool">
      <a-tooltip title="导出">
        <div class="icon-wrapper">
          <img src="@/assets/myImg/1/导出.png" alt="导出" />
        </div>
      </a-tooltip>
    </div>
    <div class="bottom-item" @click="handleLegend">
      <a-tooltip title="图例">
        <div class="icon-wrapper">
          <img src="@/assets/myImg/1/图例.png" alt="图例" />
        </div>
      </a-tooltip>
    </div>

    <div class="select-wrapper map-select-wrapper">
      <a-select v-model="selectedValue" placeholder="选择图层" style="width: 120px" size="small"
        @change="handleSelectChange" :getPopupContainer="(triggerNode) => triggerNode.parentNode">
        <a-select-option value="layer1">高德矢量</a-select-option>
        <a-select-option value="layer2">高德影像</a-select-option>
        <a-select-option value="layer3">天地影像</a-select-option>
        <a-select-option value="layer4">必应地图</a-select-option>
      </a-select>
    </div>

    <div class="select-wrapper layer-select-wrapper">
      <a-select placeholder="图层等级" style="width: 100px" size="small" @change="handleLayerChange" :value="layerLeval"
        :getPopupContainer="(triggerNode) => triggerNode.parentNode">
        <a-select-option v-for="item in layerLevelList" :value="item" :key="item">{{ item }}级片区</a-select-option>
      </a-select>
    </div>

    <div class="select-wrapper zone-select-wrapper">
      <a-select placeholder="请选择" style="width: 160px" size="small" label-in-value @change="handleZoneName"
        :value="zoneNameAndValueObj" :getPopupContainer="(triggerNode) => triggerNode.parentNode">
        <a-select-option v-for="item in zoneSelectList" :value="item.zoneId" :key="item.zoneId"
          :title="item.zoneName">{{ item.zoneName }}
        </a-select-option>
      </a-select>
    </div>

    <!-- 查询抽屉组件 -->
    <QueryDrawer 
      :visible="queryVisible" 
      :currentZoneId="currentZoneId"
      @close="handleQueryClose" 
      @location-device="handleLocationDevice" 
    />
  </div>
</template>
<script>
import QueryDrawer from './queryDrawer.vue'

export default {
  name: 'BottomMap',
  components: {
    QueryDrawer
  },
  props: {
    layerLeval: {
      type: Number,
      default: 1
    },
    layerLevelList: {
      type: Array,
      default: () => []
    },
    zoneSelectList: {
      type: Array,
      default: () => []
    },
    zoneNameAndValue: {
      type: [Array, Object],
      default: () => null
    },
    // 当前选中的分区ID
    currentZoneId: {
      type: String,
      default: ''
    }
  },
  computed: {
    // 将 zoneNameAndValue 转换为对象格式（兼容数组和对象）
    zoneNameAndValueObj () {
      if (!this.zoneNameAndValue) {
        return null;
      }
      // 如果是数组，取第一个元素
      if (Array.isArray(this.zoneNameAndValue) && this.zoneNameAndValue.length > 0) {
        return this.zoneNameAndValue[0];
      }
      // 如果是对象，直接返回
      if (typeof this.zoneNameAndValue === 'object') {
        return this.zoneNameAndValue;
      }
      return null;
    }
  },
  data () {
    return {
      selectedValue: 'layer4',
      queryVisible: false,
      // 地图图层配置对象，包含URL、坐标系和缩放级别信息
      mapLayerConfigs: {
        layer1: {
          name: '高德矢量',
          url: 'https://wprd0{1-4}.is.autonavi.com/appmaptile?lang=zh_cn&size=1&style=7&x={x}&y={y}&z={z}',
          projection: 'GCJ-02',  // 高德地图使用火星坐标系
          maxZoom: 18  // 最大缩放级别
        },
        layer2: {
          name: '高德影像',
          url: 'https://webst01.is.autonavi.com/appmaptile?style=6&x={x}&y={y}&z={z}',
          projection: 'GCJ-02',  // 高德地图使用火星坐标系
          maxZoom: 16  // 最大缩放级别
        },
        layer3: {
          name: '天地影像',
          url: 'https://t7.tianditu.gov.cn/DataServer?T=img_w&x={x}&y={y}&l={z}&tk=485cd3a62955d7a962a5c0d64d4949f2',
          projection: 'EPSG:3857',  // 天地图使用标准Web墨卡托投影
          maxZoom: 18  // 最大缩放级别
        },
        layer4: {
          name: '必应地图',
          useTileUrlFunction: true,  // 标识需要使用自定义瓦片URL函数
          projection: 'GCJ-02',  // 必应地图使用火星坐标系
          maxZoom: 18  // 最大缩放级别
        }
      }
    }
  },
  methods: {
    // 查询
    handleSearch () {
      this.queryVisible = !this.queryVisible;
    },

    // 关闭查询抽屉
    handleQueryClose () {
      this.queryVisible = false;
    },

    // 处理设备定位事件
    handleLocationDevice (locationData) {
      console.log('接收到设备定位事件:', locationData);
      // 将定位事件传递给父组件
      this.$emit('location-device', locationData);
    },

    //定位
    handlePositioning () {
      this.$emit('positioning');
    },

    //测量工具
    handleMeasureTool () {
      this.$emit('tool-click', 'measure');
    },

    //导出工具
    handleExportTool () {
      this.$emit('tool-click', 'export');
    },

    //图例
    handleLegend () {
      this.$emit('show-legend');
    },

    // 图层等级变更
    handleLayerChange (val) {
      this.$emit('layer-level-change', val);
    },

    // 分区变更
    handleZoneName (val) {
      this.$emit('zone-name-change', val);
    },

    handleSelectChange (value) {
      console.log('选择的图层:', value)

      // 获取对应的地图配置
      const selectedConfig = this.mapLayerConfigs[value]
      console.log('对应的地图配置:', selectedConfig)

      // 构建地图配置对象
      const config = {
        layerType: value,
        mapUrl: selectedConfig.url,
        projection: selectedConfig.projection,
        layerName: selectedConfig.name,
        maxZoom: selectedConfig.maxZoom
      }

      // 如果是必应地图，添加自定义瓦片URL函数
      if (selectedConfig.useTileUrlFunction) {
        config.tileUrlFunction = this.getBingTileUrlFunction()
      }

      // 向父组件传递完整的地图配置（包括URL、坐标系和缩放级别）
      this.$emit('layer-change', config)
    },

    // 必应地图瓦片URL函数
    getBingTileUrlFunction () {
      return (coord) => {
        return this.getVETileUrl(coord[0], coord[1], coord[2])
      }
    },

    // 必应地图瓦片URL生成器
    getVETileUrl (z, x, y) {
      let quadKey = ''
      let tileX = x
      let tileY = y

      for (let i = 0; i < z; i++) {
        quadKey = ((tileX & 1) + 2 * (tileY & 1)).toString() + quadKey
        tileX >>= 1
        tileY >>= 1
      }

      return 'http://dynamic.t0.tiles.ditu.live.com/comp/ch/' + quadKey + '?it=G,VE,BX,L,LA&mkt=zh-cn,syr&n=z&og=111&ur=CN'
    }
  }
}
</script>
<style lang="less" scoped>
.map-select-wrapper /deep/ .ant-select-dropdown {
  top: -130px !important;
  left: 208px !important;
}

.layer-select-wrapper {
  /deep/ .ant-select-dropdown {
    top: -130px !important;
    left: 343px !important;
    height: 137px !important;
  }

  /deep/ .ant-select-dropdown-menu {
    height: 137px !important;
  }
}

.zone-select-wrapper {
  /deep/ .ant-select-dropdown {
    top: -190px !important;
    height: 200px !important;
    left: 460px !important;
  }

  /deep/ .ant-select-dropdown-menu {
    height: 200px !important;
    //overflow-y: hidden !important;
  }
}

.bottom-map {
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  bottom: 20px;
  z-index: 1000;
  display: flex;
  gap: 8px;
  background: rgba(255, 255, 255, 0.95);
  //backdrop-filter: blur(10px);
  border-radius: 12px;
  padding: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.3s ease;

  &:hover {
    transform: translateX(-50%) translateY(-2px);
    box-shadow: 0 6px 25px rgba(0, 0, 0, 0.2);
  }
}

.bottom-item {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
  overflow: hidden;

  &:hover {
    background: rgba(24, 144, 255, 0.1);
    transform: scale(1.05);
  }

  &:active {
    transform: scale(0.95);
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, rgba(24, 144, 255, 0.1), rgba(24, 144, 255, 0.05));
    opacity: 0;
    transition: opacity 0.2s ease;
    border-radius: 8px;
  }

  &:hover::before {
    opacity: 1;
  }
}

.icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  position: relative;
  z-index: 1;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    filter: brightness(0.4) grayscale(1);
    transition: filter 0.2s ease;
  }
}

.bottom-item:hover .icon-wrapper img {
  filter: brightness(1) saturate(1.2);
}

// 响应式设计
@media (max-width: 768px) {
  .bottom-map {
    bottom: 10px;
    padding: 6px;
    gap: 6px;
  }

  .bottom-item {
    width: 36px;
    height: 36px;
  }

  .icon-wrapper {
    width: 20px;
    height: 20px;
  }
}

// 动画效果
@keyframes pulse {
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.1);
  }

  100% {
    transform: scale(1);
  }
}

.bottom-item:active {
  animation: pulse 0.3s ease;
}

// 选择器样式
.select-wrapper {
  display: flex;
  align-items: center;
  margin-left: 8px;

  :deep(.ant-select) {
    .ant-select-selector {
      background: rgba(255, 255, 255, 0.95) !important;
      border: 1px solid rgba(24, 144, 255, 0.3) !important;
      border-radius: 8px !important;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
      transition: all 0.2s ease !important;

      &:hover {
        border-color: #1890ff !important;
        box-shadow: 0 4px 12px rgba(24, 144, 255, 0.15) !important;
      }
    }

    .ant-select-selection-placeholder {
      color: #999;
      font-size: 12px;
    }

    .ant-select-selection-item {
      color: #1890ff;
      font-weight: 500;
      font-size: 12px;
    }
  }

  :deep(.ant-select-arrow) {
    color: #1890ff;
    font-size: 10px;
  }
}

// 响应式设计 - 选择器
@media (max-width: 768px) {
  .select-wrapper {
    margin-left: 4px;

    :deep(.ant-select) {
      width: 100px !important;

      .ant-select-selector {
        height: 32px !important;
      }
    }
  }
}
</style>
